import { FormContextValues } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { referralTranslationKeys } from '../translations';

const CITO_FIELD_NAME = 'cito';
type CitoCheckboxFormBeanPart = {
   [CITO_FIELD_NAME]: boolean;
};
type CitoCheckboxProps = {
   readonly register: FormContextValues<CitoCheckboxFormBeanPart>['register'];
};

export const CitoCheckbox = (props: CitoCheckboxProps): JSX.Element => {
   return (
      <Checkbox label={referralTranslationKeys.cito} controller={props.register(CITO_FIELD_NAME)} testId={'cito'} />
   );
};
